import { tableHeader } from './TableHeader.css';
import type { TPostTableHeaderProps } from './TableHeader.types';

export const PostTableHeader = (props: TPostTableHeaderProps) => {
  const { children } = props;

  return <th className={tableHeader}>{children}</th>;
};
